import React, {useState} from 'react';
import {Box, IconButton, Menu, MenuItem} from '@mui/material';
import '../Demo.scss';
import ArrDataGrid from '../../../components/common/arr-data-grid/ArrDataGrid';
import {GridColDef, GridRenderCellParams} from '@mui/x-data-grid';
import MoreVertIcon from '@mui/icons-material/MoreVert';

const DataGridDemo: React.FC = () => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [selectedRow, setSelectedRow] = useState<number | null>(null);

  const handleMenuClick = (
    event: React.MouseEvent<HTMLElement>,
    id: number
  ) => {
    setAnchorEl(event.currentTarget);
    setSelectedRow(id);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setSelectedRow(null);
  };

  const handleEdit = () => {
    console.log('Edit row:', selectedRow);
    handleMenuClose();
  };

  const handleDelete = () => {
    console.log('Delete row:', selectedRow);
    handleMenuClose();
  };

  const columns: GridColDef[] = [
    {
      field: 'firstName',
      headerName: 'First Name',
      flex: 1,
      headerClassName: 'typo-text label2_size',
    },
    {
      field: 'lastName',
      headerName: 'Last Name',
      flex: 1,
      headerClassName: 'typo-text label2_size',
    },
    {field: 'role', headerName: 'Role', flex: 1},
    {field: 'status', headerName: 'Status', flex: 1},
    {field: 'securityGroup', headerName: 'Security Group', flex: 1},
    {field: 'project', headerName: 'Project', flex: 1},
    {field: 'domain', headerName: 'Domain', flex: 1},
    {field: 'billable', headerName: 'Billable', flex: 1},
    {
      field: '',
      headerName: '',
      width: 50,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => (
        <>
          <IconButton
            onClick={(e) => handleMenuClick(e, params.row.id)}
            className="arr-datagrid__action-btn"
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl) && selectedRow === params.row.id}
            onClose={handleMenuClose}
          >
            <MenuItem onClick={handleEdit}>Edit</MenuItem>
            <MenuItem onClick={handleDelete}>Remove</MenuItem>
          </Menu>
        </>
      ),
    },
  ];

  const rows = [
    {
      id: 1,
      firstName: 'Alice',
      lastName: 'Johnson',
      role: 'Review Manager',
      status: 'Active',
      securityGroup: 'Default Security Group',
      project: 'Project Alpha',
      domain: 'Legal',
      billable: true,
    },
    {
      id: 2,
      firstName: 'Bob',
      lastName: 'Smith',
      role: 'Reviewer',
      status: 'Inactive',
      securityGroup: 'Finance Group',
      project: 'Project Beta',
      domain: 'Finance',
      billable: false,
    },
    {
      id: 3,
      firstName: 'Carol',
      lastName: 'Davis',
      role: 'Admin',
      status: 'Active',
      securityGroup: 'Admin Group',
      project: 'Project Gamma',
      domain: 'Operations',
      billable: true,
    },
    {
      id: 4,
      firstName: 'David',
      lastName: 'Miller',
      role: 'Support',
      status: 'Pending',
      securityGroup: 'Support Group',
      project: 'Project Delta',
      domain: 'Support',
      billable: false,
    },
    {
      id: 5,
      firstName: 'Evelyn',
      lastName: 'Wilson',
      role: 'Reviewer',
      status: 'Active',
      securityGroup: 'Default Security Group',
      project: 'Project Omega',
      domain: 'Compliance',
      billable: true,
    },
    {
      id: 6,
      firstName: 'Frank',
      lastName: 'Brown',
      role: 'Review Manager',
      status: 'Suspended',
      securityGroup: 'Audit Group',
      project: 'Project Sigma',
      domain: 'Audit',
      billable: false,
    },
    {
      id: 7,
      firstName: 'Grace',
      lastName: 'Taylor',
      role: 'Reviewer',
      status: 'Active',
      securityGroup: 'Legal Group',
      project: 'Project Theta',
      domain: 'Legal',
      billable: true,
    },
    {
      id: 8,
      firstName: 'Henry',
      lastName: 'Anderson',
      role: 'Support',
      status: 'Inactive',
      securityGroup: 'Support Group',
      project: 'Project Lambda',
      domain: 'IT',
      billable: false,
    },
    {
      id: 9,
      firstName: 'Ivy',
      lastName: 'Thomas',
      role: 'Admin',
      status: 'Active',
      securityGroup: 'Admin Group',
      project: 'Project Zeta',
      domain: 'Security',
      billable: true,
    },
    {
      id: 10,
      firstName: 'Jack',
      lastName: 'Martinez',
      role: 'Reviewer',
      status: 'Pending',
      securityGroup: 'Finance Group',
      project: 'Project Epsilon',
      domain: 'Finance',
      billable: false,
    },
  ];
  return (
    <Box className="demo-page modal-demo">
      <h1>Grid</h1>
      <ArrDataGrid
        rows={rows}
        columns={columns}
        rowCount={5146}
        paginationModel={{page: 0, pageSize: 15}}
        onPaginationModelChange={(model) => console.log('Page change:', model)}
      />
    </Box>
  );
};

export default DataGridDemo;
